export const en = {
    add: 'Add to ad group'
};
